import { render, staticRenderFns } from "./MissedCalls.vue?vue&type=template&id=529d17e6&scoped=true&"
import script from "./MissedCalls.vue?vue&type=script&lang=js&"
export * from "./MissedCalls.vue?vue&type=script&lang=js&"
import style0 from "./MissedCalls.vue?vue&type=style&index=0&id=529d17e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529d17e6",
  null
  
)

export default component.exports